/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".survey-view-percent[_ngcontent-%COMP%]{width:70px;flex-shrink:0}.survey-view-locations[_ngcontent-%COMP%]{width:93px;flex-shrink:0}"];
export { styles as styles };
